import * as React from "react";
import {ReactComponent as GlyftyLogo} from "../img/glyfty.svg";

export const PoweredBy = () => <div className="powered-by">
    Powered by
    <GlyftyLogo className="logo-tiny"/>
    <span className="glyfty-text">Glyfty</span>
</div>
